var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"logo-competo",attrs:{"src":"/img/COMPETO_LOGO_2024_white.svg","alt":"Competo Logo"}})}
var staticRenderFns = []

export { render, staticRenderFns }